import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectMainSkinById, setEditId } from "../../../store/mods_factory/mainSkinsSlice";
import { destroyMainSkin, fetchMainSkin } from "../../../actions/mods_factory/mainSkinsActions";
import { fetchCategories } from "../../../actions/mods_factory/categoriesActions";

import {
  LikeOutlined,
  MessageOutlined,
  StarOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import { message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import IconText from "../../../componets/IconText";
import StatsIcons from "../../../componets/StatsIcons";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import EditCategory from "../categories/Edit";
import ReorderCategories from "../categories/Reorder";
import NewCategory from "../categories/New";
import Details from "./_partials/_Details";
import Comments from "./_partials/_Comments";
import EditComment from "../Comments/Edit";
import { ButtonDestroy, ButtonEdit } from "../../../componets/Buttons";
import modsfactoryUrls from "../../../configs/mods_factory/modsfactoryUrls";

const TARGET_ID = 5;

const Show: React.FC = () => {
  const { id }        = useParams();
  const navigate      = useNavigate();
  const dispatch      = useAppDispatch();
  const mainSkin = useAppSelector(state => id ? selectMainSkinById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchMainSkin(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (mainSkin) {
      dispatch(setEditId(mainSkin.id));
    }
  }

  function onClickDestroy() {
    if (mainSkin) {
      handleDestroy(mainSkin.id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyMainSkin(id));

    if (destroyMainSkin.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(modsfactoryUrls.mainSkinsPath()), 1000);
    }

    if (destroyMainSkin.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-mainSkins-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            mainSkin &&
              <SummaryShow
                title={mainSkin.title}
                image={mainSkin.thumbnail_url}
                createdAt={mainSkin.created_at}
                updatedAt={mainSkin.updated_at}
                className='v-mb-15'
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />
                ]}
              />
          }

          <StatsIcons
            icons={[
              <IconText tooltip='popular' icon={StarOutlined} text={mainSkin?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={mainSkin?.likes_count} />,
              <IconText tooltip='downloads' icon={DownloadOutlined} text={mainSkin?.downloads_count} />,
              <IconText tooltip='comments' icon={MessageOutlined} text={mainSkin?.comments_count} />
            ]}
          />
        </div>

        <Tabs
          paramsKey='tab'
          items={[
            { label: 'Details', key: 'details', children: <Details mainSkin={mainSkin} /> },
            { label: 'Comments', key: 'comment', children: <Comments mainSkinId={mainSkin?.id} /> }
          ]}
        />
      </div>

      <SidebarShow mainSkin={mainSkin} />

      <Edit />

      <NewCategory />
      <EditCategory />
      <ReorderCategories />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
